export const getHistoryLockData = (state) => state.HistoryLockData.Data;
